import {
  GetSaleProductsPreviewQuery,
  GetSaleProductsPreviewQueryVariables,
  GetSaleProductsPreviewDocument,
} from '@/lib/graphql/generated/graphql';
import { QueryHookOptions, useQuery } from '@apollo/client/react';

export const useSaleProductsPreview = (
  brandId: string,
  saleId: string,
  options?: Omit<
    QueryHookOptions<
      GetSaleProductsPreviewQuery,
      GetSaleProductsPreviewQueryVariables
    >,
    'variables'
  >
) => {
  const { data, loading, error } = useQuery(GetSaleProductsPreviewDocument, {
    variables: { brandId, saleId },
    skip: !brandId || !saleId,
    ...(options ?? {}),
  });

  return {
    products: data?.saleProductsPreview || [],
    loading,
    error,
  };
};
